export default {
	Calendar: {
		width : '330px'
	}
};


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/calendar/calendar-theme-rewrite.js